import React, { useState } from 'react';
import { Parallax } from 'react-parallax';
import { motion, AnimatePresence } from 'framer-motion';
import { wrap } from '@popmotion/popcorn';

import { StandardBlockWrapper } from './standardBlockWrapper';
import { PortableTextBlock } from '../sanity/portableTextBlock';

const CarouselItem = ({ image, _rawText, ...rest }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} {...rest}>
      <Parallax
        className="relative w-full h-96 flex justify-center items-center md:h-120 px-gutter overflow-hidden text-white"
        bgImage={image && image.asset && image.asset.url}
        strength={100}
        bgImageStyle={{ opacity: 0.5, objectFit: 'cover', height: '120%' }}
      >
        <PortableTextBlock
          text={_rawText}
          className="z-20 prose prose-sm lg:prose-xl text-white text-center max-w-4xl w-full"
        />
      </Parallax>
    </motion.div>
  );
};

const TextCarousel = ({ items, padding, backgroundColor }) => {
  const [pageIndex, setPageIndex] = useState(0);
  const wrappedIndex = wrap(0, items.length, pageIndex);

  return (
    <StandardBlockWrapper padding={padding} backgroundColor={backgroundColor}>
      <div className="bg-black relative">
        {items.length && (
          <AnimatePresence exitBeforeEnter>
            <CarouselItem {...items[wrappedIndex]} key={pageIndex} />
          </AnimatePresence>
        )}
        {items.length && (
          <nav className="flex justify-center my-4 absolute bottom-8 left-0 z-40 w-full">
            {items.map((item, index) => (
              <button
                onClick={() => setPageIndex(index)}
                className={`rounded-full bg-white h-3 w-3 mx-1 focus:outline-none ${
                  pageIndex === index ? 'opacity-100' : 'opacity-40'
                }`}
              />
            ))}
          </nav>
        )}
      </div>
    </StandardBlockWrapper>
  );
};

export default TextCarousel;
